// extracted by mini-css-extract-plugin
export default {"text":"profile-button_text__VXz5H","profile-button":"profile-button_profile-button__EGezO"};